import { api } from "../Configurations/axios";

const PutValueIndebtedness = async (id: string, value: number, userEmail: string, type: string, companyId: string) => {
    try {
        const result = await api.put('/Indebtedness/PutValuesOnIndebtedness', { id: id, userEmail: userEmail, type: type, value: value, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    PutValueIndebtedness
}